import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-552d9e6b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "profile_contents_wrapper" }
const _hoisted_2 = { class: "profile_button_deactive" }
const _hoisted_3 = { class: "profile_button_deactive_inner" }

import { ref } from 'vue';
import { getMailAddress, getUserBasicInfo } from '@/api/careersheetEndpoint';
import { getMasterDataListPref, getMasterDataListSex } from '@/api/masterDataEndpoint';
import BaseButton from '@/components/BaseButton.vue';
import Loading from '@/components/Loading.vue';
import Breadcrumbs from '@/components/Breadcrumbs.vue';
import Profile from '@/components/Profile.vue';
import { stringToDate, ymdFormat } from '@/utils/dateFormat';
import { useRouter } from 'vue-router';
import { telCellularAddHyphen } from '@/utils/stringfilter';
import store from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileView',
  setup(__props) {

const router = useRouter();
const isLoading = ref(false);
const breadcrumbs = [
  {
    label: 'ホーム',
    name: 'f00',
  },
  {
    label: '基本情報',
  },
];
const fullName = ref('');
const fullNameKana = ref('');
const sex = ref('');
const birthday = ref('');
const telCellular = ref('');
const zipCode = ref('');
const pref = ref('');
const addr1 = ref('');
const addr2 = ref('');
const addr3 = ref('');
const email = ref('');

const init = async () => {
  isLoading.value = true;
  try {
    const [basicRes, mailRes, mstSexRes, mstPrefRes] = await Promise.all([
      getUserBasicInfo(),
      getMailAddress(),
      getMasterDataListSex(),
      getMasterDataListPref(),
      store.dispatch('userMenu/receive'),
    ]);

    fullName.value = basicRes.lastName + basicRes.firstName;
    fullNameKana.value = basicRes.lastNameKana + basicRes.firstNameKana;
    sex.value = mstSexRes.filter((i) => i.code === basicRes.sexFlg)[0]?.name || '';
    birthday.value = ymdFormat(stringToDate(basicRes.birthDate)) || '';
    telCellular.value = basicRes.telCellular ? telCellularAddHyphen(basicRes.telCellular) : '';
    zipCode.value = basicRes.zipCode ? basicRes.zipCode.replace(/^([0-9]{3})([0-9]{4})/, '〒$1-$2') : '';
    pref.value = mstPrefRes.filter((i) => i.code === basicRes.prefId)[0]?.name || '';
    addr1.value = basicRes.addr1 || '';
    addr2.value = basicRes.addr2 || '';
    addr3.value = basicRes.addr3 || '';
    email.value = mailRes.emailAddress || '';
  } catch (e) {
    console.error(e);
  } finally {
    isLoading.value = false;
  }
};
init();

const transitionEditBasicPage = () => {
  router.push({ name: 'e21' });
};

const transitionEditMailPage = () => {
  router.push({ name: 'e23' });
};

const transitionEditPasswordPage = () => {
  router.push({ name: 'e25' });
};

const transitionDeactivatePage = () => {
  router.push({ name: 'p00' });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", null, [
    _createVNode(Loading, { "is-loading": isLoading.value }, null, 8, ["is-loading"]),
    (!isLoading.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(Breadcrumbs, { breadcrumbs: breadcrumbs }),
          _createElementVNode("div", _hoisted_1, [
            _createVNode(Profile, {
              fullName: fullName.value,
              fullNameKana: fullNameKana.value,
              sex: sex.value,
              birthday: birthday.value,
              telCellular: telCellular.value,
              zipCode: zipCode.value,
              pref: pref.value,
              addr1: addr1.value,
              addr2: addr2.value,
              addr3: addr3.value,
              email: email.value,
              onTransitionEditBasicPage: transitionEditBasicPage,
              onTransitionEditMailPage: transitionEditMailPage,
              onTransitionEditPasswordPage: transitionEditPasswordPage
            }, null, 8, ["fullName", "fullNameKana", "sex", "birthday", "telCellular", "zipCode", "pref", "addr1", "addr2", "addr3", "email"]),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(BaseButton, {
                  theme: "tertiary",
                  onClick: transitionDeactivatePage
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("退会について")
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

})